import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-notification__content" }
const _hoisted_2 = {
  key: 0,
  class: "app-notification__title"
}
const _hoisted_3 = { class: "app-notification__message" }
const _hoisted_4 = { class: "app-notification__actions" }

import type {
  NotificationAction,
  NotificationVariant,
} from '@/services/notification.app'
import AppButton from '@/app/components/button/AppButton.vue'
import Confetti from '@/components/ui/Confetti.vue'
import AppNotificationIcon from './AppNotificationIcon.vue'

/**
 * This is component is bare component for displaying notifications.
 * It defines specific styles for the different variants.
 *
 * @param variant (NotificationVariant) - Visual style variant:
 * 'unique' | 'success' | 'error' | 'warning' | 'info'. Default: 'unique'
 * @param actions (NotificationAction[]) - Array of action buttons with
 * `{ label: string, onClick: () => void }`. Default: []
 *   Note - if no actions are passed, the close button is displayed
 *        you can use the action slot to override all default action behavior
 * @param compact (boolean) - Compact confirmation style: the message with a
 * trailing outlined action, and no icon or close button. Default: false
 * @event close - Emitted when the close button is clicked
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotification',
  props: {
    variant: { default: 'unique' },
    actions: { default: () => ([]) },
    confetti: { type: Boolean, default: false },
    compact: { type: Boolean, default: false }
  },
  emits: ['close'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'app-notification',
      `app-notification--${__props.variant}`,
      { 'app-notification--compact': __props.compact },
    ])
  }, [
    (__props.confetti)
      ? (_openBlock(), _createBlock(Confetti, {
          key: 0,
          class: "app-notification__confetti"
        }))
      : _createCommentVNode("", true),
    (!__props.compact)
      ? (_openBlock(), _createBlock(AppNotificationIcon, {
          key: 1,
          class: "app-notification__icon",
          variant: __props.variant
        }, null, 8, ["variant"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.title)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_3, [
        _renderSlot(_ctx.$slots, "message")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "action", {}, () => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action, index) => {
          return (_openBlock(), _createBlock(AppButton, {
            key: index,
            dense: true,
            outlined: __props.compact || index !== 0,
            class: "app-notification__action",
            onClick: ($event: any) => (action.onClick())
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(action.label), 1)
            ]),
            _: 2
          }, 1032, ["outlined", "onClick"]))
        }), 128))
      ])
    ]),
    (!__props.compact)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "app-notification__close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "app-notification__close-icon iconfont iclose-thin" }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})